// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "./SelfLearningHierarchyQueryList";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_3, decodeBinary as decodeBinary_3, } from "./SelfLearningHierarchyConfig";
import { WireType, } from "../../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../../runtime/wire/serialize";
import { encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "../../../../../google/protobuf/Int64Value";
import { default as deserialize, } from "../../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        queries: undefined,
        parentId: undefined,
        config: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.queries !== undefined)
        result.queries = encodeJson_1(value.queries);
    if (value.parentId !== undefined)
        result.parentId = value.parentId;
    if (value.config !== undefined)
        result.config = encodeJson_2(value.config);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.queries !== undefined)
        result.queries = decodeJson_1(value.queries);
    if (value.parentId !== undefined)
        result.parentId = value.parentId;
    if (value.config !== undefined)
        result.config = decodeJson_2(value.config);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.queries !== undefined) {
        const tsValue = value.queries;
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.parentId !== undefined) {
        const tsValue = value.parentId;
        result.push([2, ((tsValue) => ({ type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }))({ value: tsValue })]);
    }
    if (value.config !== undefined) {
        const tsValue = value.config;
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_3(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    var _a;
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.queries = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = (_a = (wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined)) === null || _a === void 0 ? void 0 : _a.value;
        if (value === undefined)
            break field;
        result.parentId = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_3(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.config = value;
    }
    return result;
}
